const PLACEHOLDER = /\{([0-9a-zA-Z_]+)\}/g;

/**
 * A simple string template function based on named arguments.
 * `{{name}}` is kept as `{name}`; missing, `null` and `undefined` fields are replaced by an empty string.
 *
 * @param {string} string Source string.
 * @param {object} fields Fields for replace.
 */
export default function formatString(string, fields) {
  const validString = string.replace(/<</g, '{').replace(/>>/g, '}');
  const values = fields && fields.hasOwnProperty ? fields : {};

  return validString.replace(PLACEHOLDER, (match, name, index) => {
    if (validString[index - 1] === '{' && validString[index + match.length] === '}') {
      return name;
    }

    const value = Object.prototype.hasOwnProperty.call(values, name) ? values[name] : null;

    return value === null || value === undefined ? '' : value;
  });
}
